export default __webpack_public_path__ + "static/media/bitmap1.3070d882.svg";